export interface AreaData {
  name: string;
  name_zh: string;
}

export const AREA_DATA: AreaData[] = [
  {
    name: 'ALL',
    name_zh: '全選',
  },
  {
    name: 'Hong Kong Island',
    name_zh: '\u9999\u6E2F\u5CF6',
  },
  {
    name: 'Kowloon',
    name_zh: '\u4E5D\u9F8D',
  },
  {
    name: 'New Territories',
    name_zh: '\u65B0\u754C',
  },
  {
    name: 'Outlying Islands',
    name_zh: '\u96E2\u5CF6',
  },
  // {
  //   name: 'Macau',
  //   name_zh: '\u6FB3\u9580',
  // },
];

export interface DistrictData {
  name: string;
  name_zh: string;
  area?: string;
}

export interface DistrictMapProps {
  [areaName: string]: DistrictData[];
}

export const ALL_DISTRICTS = 'All Districts';
export const ALL_AREA = 'All Districts|全選地區';

export const DISTRICT_MAP: DistrictMapProps = {
  ALL: [
    {
      name: 'All Districts',
      name_zh: '全選地區',
      area: 'ALL',
    },
  ],
  'Hong Kong Island': [
    {
      name: 'Aberdeen',
      name_zh: '\u9999\u6E2F\u4ED4',
      area: 'Hong Kong Island',
    },
    {
      name: 'Admiralty',
      name_zh: '\u91D1\u9418',
      area: 'Hong Kong Island',
    },
    {
      name: 'Ap Lei Chau',
      name_zh: '\u9D28\u5229\u6D32',
      area: 'Hong Kong Island',
    },
    {
      name: 'Causeway Bay',
      name_zh: '\u9285\u947C\u7063',
      area: 'Hong Kong Island',
    },
    {
      name: 'Central',
      name_zh: '\u4E2D\u74B0',
      area: 'Hong Kong Island',
    },
    {
      name: 'Chai Wan',
      name_zh: '\u67F4\u7063',
      area: 'Hong Kong Island',
    },
    {
      name: 'Chi Fu',
      name_zh: '\u7F6E\u5BCC',
      area: 'Hong Kong Island',
    },
    {
      name: 'Fortress Hill',
      name_zh: '\u70AE\u53F0\u5C71',
      area: 'Hong Kong Island',
    },
    {
      name: 'Happy Valley',
      name_zh: '\u8DD1\u99AC\u5730',
      area: 'Hong Kong Island',
    },
    {
      name: 'Kennedy Town',
      name_zh: '\u5805\u5C3C\u5730\u57CE',
      area: 'Hong Kong Island',
    },
    {
      name: 'Mid Levels',
      name_zh: '\u534A\u5C71',
      area: 'Hong Kong Island',
    },
    {
      name: 'North Point',
      name_zh: '\u5317\u89D2',
      area: 'Hong Kong Island',
    },
    {
      name: 'Pok Fu Lam',
      name_zh: '\u8584\u6276\u6797',
      area: 'Hong Kong Island',
    },
    {
      name: 'Quarry Bay',
      name_zh: '\u9C02\u9B5A\u6D8C',
      area: 'Hong Kong Island',
    },
    {
      name: 'Sai Wan Ho',
      name_zh: '\u897F\u7063\u6CB3',
      area: 'Hong Kong Island',
    },
    {
      name: 'Sai Ying Pun',
      name_zh: '\u897F\u71DF\u76E4',
      area: 'Hong Kong Island',
    },
    {
      name: 'Sau Kei Wan',
      name_zh: '\u7B72\u7B95\u7063',
      area: 'Hong Kong Island',
    },
    {
      name: 'Shau Kei Wan',
      name_zh: '\u7B72\u7B95\u7063',
      area: 'Hong Kong Island',
    },
    {
      name: 'Sheung Wan',
      name_zh: '\u4E0A\u74B0',
      area: 'Hong Kong Island',
    },
    {
      name: 'Siu Sai Wan',
      name_zh: '\u5C0F\u897F\u7063',
      area: 'Hong Kong Island',
    },
    {
      name: 'Stanley',
      name_zh: '\u8D64\u67F1',
      area: 'Hong Kong Island',
    },
    {
      name: 'Taikoo Shing',
      name_zh: '\u592A\u53E4\u57CE',
      area: 'Hong Kong Island',
    },
    {
      name: 'Tin Hau',
      name_zh: '\u5929\u540E',
      area: 'Hong Kong Island',
    },
    {
      name: 'Wah Fu Estate',
      name_zh: '\u83EF\u5BCC\u90A8',
      area: 'Hong Kong Island',
    },
    {
      name: 'Wan Chai',
      name_zh: '\u7063\u4ED4',
      area: 'Hong Kong Island',
    },
    {
      name: 'Western District',
      name_zh: '\u897F\u5340',
      area: 'Hong Kong Island',
    },
  ],
  Kowloon: [
    {
      name: 'Cheung Sha Wan',
      name_zh: '\u9577\u6C99\u7063',
      area: 'Kowloon',
    },
    {
      name: 'Choi Hung',
      name_zh: '\u5F69\u8679',
      area: 'Kowloon',
    },
    {
      name: 'Choi Wan',
      name_zh: '\u5F69\u96F2',
      area: 'Kowloon',
    },
    {
      name: 'Diamond Hill',
      name_zh: '\u947D\u77F3\u5C71',
      area: 'Kowloon',
    },
    {
      name: 'Ho Man Tin',
      name_zh: '\u4F55\u6587\u7530',
      area: 'Kowloon',
    },
    {
      name: 'Hung Hom',
      name_zh: '\u7D05\u78E1',
      area: 'Kowloon',
    },
    {
      name: 'Jordan',
      name_zh: '\u4F50\u6566',
      area: 'Kowloon',
    },
    {
      name: 'Kowloon Bay',
      name_zh: '\u4E5D\u9F8D\u7063',
      area: 'Kowloon',
    },
    {
      name: 'Kowloon City',
      name_zh: '\u4E5D\u9F8D\u57CE',
      area: 'Kowloon',
    },
    {
      name: 'Kwun Tong',
      name_zh: '\u89C0\u5858',
      area: 'Kowloon',
    },
    {
      name: 'Lai Chi Kok',
      name_zh: '\u8354\u679D\u89D2',
      area: 'Kowloon',
    },
    {
      name: 'Lam Tin',
      name_zh: '\u85CD\u7530',
      area: 'Kowloon',
    },
    {
      name: 'Lok Fu',
      name_zh: '\u6A02\u5BCC',
      area: 'Kowloon',
    },
    {
      name: 'Mei Foo',
      name_zh: '\u7F8E\u5B5A',
      area: 'Kowloon',
    },
    {
      name: 'Mong Kok',
      name_zh: '\u65FA\u89D2',
      area: 'Kowloon',
    },
    {
      name: 'Mongkok',
      name_zh: '\u65FA\u89D2',
      area: 'Kowloon',
    },
    {
      name: 'Ngau Chi Wan',
      name_zh: '\u725B\u6C60\u7063',
      area: 'Kowloon',
    },
    {
      name: 'Ngau Tau Kok',
      name_zh: '\u725B\u982D\u89D2',
      area: 'Kowloon',
    },
    {
      name: 'Ping Shek',
      name_zh: '\u576A\u77F3',
      area: 'Kowloon',
    },
    {
      name: 'Prince Edward',
      name_zh: '\u592A\u5B50',
      area: 'Kowloon',
    },
    {
      name: 'San Po Kong',
      name_zh: '\u65B0\u84B2\u5D17',
      area: 'Kowloon',
    },
    {
      name: 'Sau Mau Ping ',
      name_zh: '\u79C0\u8302\u576A',
      area: 'Kowloon',
    },
    {
      name: 'Sham Shui Po',
      name_zh: '\u6DF1\u6C34\u57D7',
      area: 'Kowloon',
    },
    {
      name: 'Shek Kip Mei',
      name_zh: '\u77F3\u7864\u5C3E',
      area: 'Kowloon',
    },
    {
      name: 'Tai Kok Tsui',
      name_zh: '\u5927\u89D2\u5480',
      area: 'Kowloon',
    },
    {
      name: 'Tokwawan',
      name_zh: '\u571F\u74DC\u7063',
      area: 'Kowloon',
    },
    {
      name: 'Tsim Sha Tsui',
      name_zh: '\u5C16\u6C99\u5480',
      area: 'Kowloon',
    },
    {
      name: 'Tsz Wan Shan',
      name_zh: '\u6148\u96F2\u5C71',
      area: 'Kowloon',
    },
    {
      name: 'Wong Tai Sin',
      name_zh: '\u9EC3\u5927\u4ED9',
      area: 'Kowloon',
    },
    {
      name: 'Yau Ma Tei',
      name_zh: '\u6CB9\u9EBB\u5730',
      area: 'Kowloon',
    },
    {
      name: 'Yau Tong',
      name_zh: '\u6CB9\u5858',
      area: 'Kowloon',
    },
  ],
  'New Territories': [
    {
      name: 'Fanling',
      name_zh: '\u7C89\u5DBA',
      area: 'New Territories',
    },
    {
      name: 'Fo Tan',
      name_zh: '\u706B\u70AD',
      area: 'New Territories',
    },
    {
      name: 'Kwai Chung ',
      name_zh: '\u8475\u6D8C',
      area: 'New Territories',
    },
    {
      name: 'Kwai Fong ',
      name_zh: '\u8475\u82B3',
      area: 'New Territories',
    },
    {
      name: 'Kwai Hing',
      name_zh: '\u8475\u8208',
      area: 'New Territories',
    },
    {
      name: 'Lei Muk Shue',
      name_zh: '\u68A8\u6728\u6A39',
      area: 'New Territories',
    },
    {
      name: 'Ma On Shan',
      name_zh: '\u99AC\u978D\u5C71',
      area: 'New Territories',
    },
    {
      name: 'Sai Kung',
      name_zh: '\u897F\u8CA2',
      area: 'New Territories',
    },
    {
      name: 'Shatin',
      name_zh: '\u6C99\u7530',
      area: 'New Territories',
    },
    {
      name: 'Shek Lei',
      name_zh: '\u77F3\u68A8',
      area: 'New Territories',
    },
    {
      name: 'Shek Wai Kok',
      name_zh: '\u77F3\u570D\u89D2',
      area: 'New Territories',
    },
    {
      name: 'Sheung Shui',
      name_zh: '\u4E0A\u6C34',
      area: 'New Territories',
    },
    {
      name: 'Tai Po',
      name_zh: '\u5927\u57D4',
      area: 'New Territories',
    },
    {
      name: 'Tai Wai',
      name_zh: '\u5927\u570D',
      area: 'New Territories',
    },
    {
      name: 'Tai Wo Hau',
      name_zh: '\u5927\u7AA9\u53E3',
      area: 'New Territories',
    },
    {
      name: 'Tin Shui Wai',
      name_zh: '\u5929\u6C34\u570D',
      area: 'New Territories',
    },
    {
      name: 'Tseung Kwan O',
      name_zh: '\u5C07\u8ECD\u6FB3',
      area: 'New Territories',
    },
    {
      name: 'Tsing Yi',
      name_zh: '\u9752\u8863',
      area: 'New Territories',
    },
    {
      name: 'Tsuen Wan',
      name_zh: '\u8343\u7063',
      area: 'New Territories',
    },
    {
      name: 'Tuen Mun',
      name_zh: '\u5C6F\u9580',
      area: 'New Territories',
    },
    {
      name: 'Yuen Long',
      name_zh: '\u5143\u6717',
      area: 'New Territories',
    },
  ],
  'Outlying Islands': [
    {
      name: 'Chek Lap Kok',
      name_zh: '\u8D64\u9C72\u89D2',
      area: 'Outlying Islands',
    },
    {
      name: 'Cheung Chau',
      name_zh: '\u9577\u6D32',
      area: 'Outlying Islands',
    },
    {
      name: 'Discovery Bay',
      name_zh: '\u6109\u666F\u7063',
      area: 'Outlying Islands',
    },
    {
      name: 'Ma Wan',
      name_zh: '\u99AC\u7063',
      area: 'Outlying Islands',
    },
    {
      name: 'Tung Chung',
      name_zh: '\u6771\u6D8C',
      area: 'Outlying Islands',
    },
  ],
  // Macau: [
  //   {
  //     name: 'Macau',
  //     name_zh: '\u6FB3\u9580',
  //     area: 'Macau',
  //   },
  // ],
};

export const findArea = (values: string[], list: DistrictMapProps) => {
  let area = '';
  let includesArea = false;
  Object.keys(list).every((key) => {
    includesArea = values.includes(key);
    if (includesArea) {
      area = key;
    } else {
      area = list[key].find((a) => values.includes(a.name))?.area || '';
    }

    return !area;
  });

  return {
    area,
    includesArea,
    districts: list[area]?.map((a) => a.name),
  };
};

export const FLATTENED_DISTRICTS = (list: DistrictMapProps) => {
  return Object.keys(list).reduce((acc: DistrictData[], cur) => {
    return [...acc, ...list[cur]];
  }, []);
};

export const INFLATED_DISTRICT = (val: string, list: { areaData: AreaData[]; districtData: DistrictMapProps }) => {
  const district = FLATTENED_DISTRICTS(list.districtData).find((d) => d.name === val || d.name_zh === val);
  const area = list.areaData.find((a) => a.name === val || a.name_zh === val);

  const inflatedDistrict = district ? `${district.name}|${district.name_zh}` : '';
  const inflatedArea = area ? `${area.name}|${area.name_zh}` : '';
  return inflatedDistrict || inflatedArea;
};

export const findAreaByDistrict = (val: string, list: DistrictMapProps) => {
  return Object.keys(list).reduce((acc, cur) => {
    const target = list[cur].find((a) => val === a.name);
    if (target?.area) acc = target.area;
    return acc;
  }, '');
};
